
import { computed, defineComponent } from 'vue';
import { useStore } from '@/store';
import AppLogo from '@/components/AppLogo.vue';

export default defineComponent({
  components: {
    AppLogo,
  },
  setup() {
    const store = useStore();
    const menuVisible = computed(() => store.state.navActive);
    const light = computed(() => store.state.navLight || store.state.navActive);
    const toggleMenu = () => {
      if (menuVisible.value) {
        store.commit.setNavActive(false);
        document.body.style.overflow = '';
      } else {
        store.commit.setNavActive(true);
        document.body.style.overflow = 'hidden';
      }
    };

    return { light, menuVisible, toggleMenu };
  },
});
